export default __webpack_public_path__ + "static/media/Sasha.39ec93a4.jpg";